import { render, staticRenderFns } from "./IconExchange.vue?vue&type=template&id=4d529691&scoped=true&"
var script = {}
import style0 from "./IconExchange.vue?vue&type=style&index=0&id=4d529691&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d529691",
  null
  
)

export default component.exports